module.exports = __webpack_public_path__ + "static/media/logo.f0c08b63.png";